import React from "react";
import { MDBBtn, MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import { keycloak } from "./keycloak";

export default function AuthError({ message }) {
  return (
    <div className="spinner-wrapper">
      <MDBCard style={{ maxWidth: "28rem" }}>
        <MDBCardBody className="text-center">
          <h5 className="mb-3">Unable to load the app</h5>
          <p className="mb-4">{message}</p>
          <MDBBtn className="me-2" onClick={() => window.location.reload()}>
            Retry
          </MDBBtn>
          <MDBBtn color="light" onClick={() => keycloak.logout()}>
            Sign out
          </MDBBtn>
        </MDBCardBody>
      </MDBCard>
    </div>
  );
}
